module.exports = __webpack_public_path__ + "static/media/23.6ed40bd0.jpg";